import { useState } from 'react';
import Hero from './components/Hero';
import ServiceOverview from './components/ServiceOverview';
import RequestForm from './components/RequestForm';
import AreasServed from './components/AreasServed';
import FAQSection from './components/FAQSection';
import ContactDetails from './components/ContactDetails';
import AboutUs from './components/AboutUs';
import Footer from './components/Footer';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <Hero />
      <ServiceOverview />
      <RequestForm />
      <AreasServed />
      <FAQSection />
      <ContactDetails />
      <AboutUs />
      <Footer />
    </div>
  );
}